export default __webpack_public_path__ + "static/media/extendbi.logo.a14df2e7.png";